module.exports = require("winston-cloudwatch");